import { styled } from '@mui/material';
import { Switch as MuiSwitch } from '@mui/material';

// Component styles
export const contentContainerStyles = {
    display: 'flex',
    gap: 1,
    flex: 1,
    overflow: 'hidden',
    mt: 1
};

export const leftColumnStyles = {
    flex: '1 1 35%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
};

export const rightColumnStyles = {
    flex: '1 1 65%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0
};

export const tabsStyles = (theme) => ({
    borderBottom: 1,
    borderColor: 'divider',
    '& .MuiTab-root': {
        minWidth: 0,
        px: 1.5,
        py: 0.75,
        fontSize: '0.8rem',
        textTransform: 'none'
    },
    '& .Mui-selected': {
        color: theme.palette.primary.main,
        fontWeight: 500
    }
});

export const tabContentStyles = {
    flex: 1,
    overflow: 'visible'
};

export const rightCardContentStyles = (cardContentStyles) => ({
    ...cardContentStyles,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    pb: 0,
    minHeight: 0,
    overflow: 'auto'
});

// Styled components
export const ModeSwitch = styled((props) => (
    <MuiSwitch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        {...props}
    />
))(({ theme }) => ({
    width: 34,
    height: 18,
    padding: 0,
    margin: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 1,
        transitionDuration: '250ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main,
                opacity: 0.85,
                border: 0,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 16,
        height: 16,
        boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 10,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[400],
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 250,
        }),
    },
}));

// Plan chips container styles
export const planChipsContainerStyles = {
    position: 'absolute',
    right: '10%',
    transform: 'translateX(-9%)',
    width: '50%',
    maxWidth: '50vw',
};

export const planChipsScrollStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    pb: 0.5,
    '&::-webkit-scrollbar': {
        height: 2,
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: 'rgba(0,0,0,0.1)',
        borderRadius: 3,
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,0.3)',
        borderRadius: 3,
    },
};

export const planChipStyles = (theme, isActive) => ({
    fontWeight: 600,
    fontSize: '1rem',
    px: 2,
    cursor: 'pointer',
    border: isActive ? `2px solid ${theme.palette.primary.main}` : undefined,
    flexShrink: 0,
});

export const stickyTitleStyles = (theme) => ({
    position: 'sticky',
    top: 0,
    zIndex: 2,
    bgcolor: theme.palette.background.paper,
    pb: 0,
    mb: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
});

export const emptyStateStyles = (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    color: theme.palette.text.disabled,
    p: 1
});